import { ReactNode, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

const readStorage = (key: string) => {
    try {
        return sessionStorage.getItem(key);
    } catch {
        return null;
    }
};

const writeStorage = (key: string, value: string) => {
    try {
        sessionStorage.setItem(key, value);
    } catch {
        // storage unavailable (private mode, blocked site data) - the URL still works on its own
    }
};

interface SessionFiltersGateProps {
    // Unique per screen, so filters of one screen never leak into another
    storageKey: string;
    // One-shot params (e.g. notification deep links) that must not be replayed on the next visit
    excludeParams?: string[];
    children: ReactNode;
}

function SessionFiltersGate({ storageKey, excludeParams = [], children }: SessionFiltersGateProps) {
    const { search } = useLocation();
    const saved = readStorage(storageKey);
    const shouldRestore = !search && !!saved;
    const excludeKey = excludeParams.join(",");

    useEffect(() => {
        if (!search) return;
        const params = new URLSearchParams(search);
        excludeKey.split(",").filter(Boolean).forEach((key) => params.delete(key));
        writeStorage(storageKey, params.toString());
    }, [search, storageKey, excludeKey]);

    if (shouldRestore) {
        return <Navigate to={{ search: `?${saved}` }} replace />;
    }

    return <>{children}</>;
}

export default SessionFiltersGate;
